import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { store, ScreenComponentProps, ShelfComponentProps, ComponentDesc } from '../store';
import { observer } from 'mobx-react';
import withStyles from 'react-jss';
import { observable } from 'mobx';
import { settingsComponentStyles, shelfComponentStyles } from './common/styles';
import { flowRight } from 'lodash';

const svg = require('./icons/shortcode.svg');
//const menu_button = require('./icons/menu_button.svg');

interface ShortCodeSettings {
    text: string;
}

let defaultTemplate = {
    type: 'SHORTCODE',
    style: {},
    settings: {
        text: '',
    },
    name: 'Shortcode',
};

function submitShortcode(str: string) {
    if (store.callbacks.doShortCode) {
        return store.callbacks.doShortCode(str);
    }
    return Promise.resolve('');
}

let shelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props, monitor, component): ComponentDesc<ShortCodeSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        (connect: DragSourceConnector, monitor: DragSourceMonitor) => {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Short Code</span>
            </div>
        </div>
    );
});

function ScreenComponent({ connectDragSource, isDragging, descriptor }: ScreenComponentProps<ShortCodeSettings>) {
    return (
        <div
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
                minHeight: '10px',
                border: '1px solid #D5EFF6',
                ...descriptor.style,
            }}
            onClick={(e) => store.selectComponent(descriptor)}
            dangerouslySetInnerHTML={{
                __html: descriptor.settings.text ? descriptor.settings.text : '',
            }}
        />
    );
}

let settingsStore = observable({
    userInput: '',
});

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(({ descriptor, classes }: any) => {
    return (
        <div
            style={{
                paddingLeft: 10,
                marginBottom: 10,
                paddingBottom: 10,
                backgroundColor: '#F2F2F5',
                color: '#2F343E',
                borderBottom: '1px solid #CDCED1',
            }}>
            <div
                style={{
                    display: 'flex',
                    //height: 115,
                    marginTop: 10,
                }}>
                <span
                    className={classes.header}
                    style={{
                        marginTop: '5px',
                        width: '89px',
                    }}>
                    ShortCode
                </span>

                <input type="text" value={settingsStore.userInput} onChange={(e) => (settingsStore.userInput = e.target.value)} className={classes.src} />
            </div>
            <div>
                <button
                    style={{
                        marginLeft: '90px',
                        marginTop: '5px',
                    }}
                    onClick={(e) => submitShortcode(settingsStore.userInput).then((t) => (descriptor.settings.text = t))}
                    className={classes.button}>
                    Submit
                </button>
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'SHORTCODE',
    type: 'component',
    shelfComponent: shelfComponent,
    screenComponent: observer(ScreenComponent),
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

//export default component;
